/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dx-modal-content-host-wrapper[_ngcontent-%COMP%]{min-height:60px;min-width:600px}\n/*# sourceMappingURL=dx-edit-modal.component.css.map*/"];
export { styles as styles };
